import type { ClientBasedAuth } from '@atlaskit/media-core/auth';
import { ObjectRecorder } from '../src/ObjectRecorder.ts';

export const mediaConfigRecorder: ObjectRecorder<ClientBasedAuth> =
	new ObjectRecorder<ClientBasedAuth>();
export const jiraMediaConfigRecorder: ObjectRecorder<ClientBasedAuth> =
	new ObjectRecorder<ClientBasedAuth>();
export const mediaConfigEnforceDSPRecorder: ObjectRecorder<boolean> = new ObjectRecorder<boolean>();
/** Icon tiles the Context byline painted on the server, keyed by content id (byline-connections). */
export const bylineTileCountsRecorder: ObjectRecorder<Record<string, number>> = new ObjectRecorder<
	Record<string, number>
>();
